export default {
  resources: (state) => state.resources,
  resourceIdList: (state) => state.resourceIdList,
  resource: (state) => state.resource
}
